"use client"

import { useEffect, useRef } from "react"
import { common, createLowlight } from "lowlight"
import { toHtml } from "hast-util-to-html"

const lowlight = createLowlight(common)

interface ArticleContentProps {
  content: string
  className?: string
}

export function ArticleContent({ content, className = "" }: ArticleContentProps) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!containerRef.current) return

    // Find all code blocks and apply syntax highlighting
    const codeBlocks = containerRef.current.querySelectorAll("pre code")

    codeBlocks.forEach((codeElement) => {
      const code = codeElement.textContent || ""

      // Try to detect language from class (e.g., "language-jsx")
      const langClass = Array.from(codeElement.classList).find((c) => c.startsWith("language-"))
      const lang = langClass?.replace("language-", "") || ""

      try {
        // Highlight the code
        const highlighted = lang && lowlight.registered(lang) ? lowlight.highlight(lang, code) : lowlight.highlightAuto(code)

        // Convert HAST to HTML string
        const html = toHtml(highlighted)
        codeElement.innerHTML = html
      } catch {
        // If highlighting fails, leave the code as-is
        console.warn(`Failed to highlight code block with language: ${lang}`)
      }
    })
  }, [content])

  return <div ref={containerRef} className={`prose-article ${className}`} dangerouslySetInnerHTML={{ __html: content }} />
}

